module.exports = __webpack_public_path__ + "static/media/PythonCertificate.d6b66e5c.jpg";